// extracted by mini-css-extract-plugin
module.exports =  {"section":"FKkVfBR","equal-padding":"Oe1C2mo","equalPadding":"Oe1C2mo","fluid":"CwPy7mD"};